function TextError(props: any) {
  return (
    <div className='fv-plugins-message-container'>
      <div className='fv-help-block'>
        <span role='alert'>{props.children}</span>
      </div>
    </div>
  );
}

export default TextError;
